import type { ReactNode } from "react";
import { DockedPanel } from "../../../components/DockedPanel";

/** What a panel is made of, so one body can be drawn in the docked panel on Ranking or in job setup's own card. */
export interface PanelParts {
  readonly title: string;
  readonly sub: string;
  readonly onClose: () => void;
  readonly footer: ReactNode;
  readonly children: ReactNode;
}

export type RenderPanel = (parts: PanelParts) => ReactNode;

export function dockedPanel(parts: PanelParts): ReactNode {
  return (
    <DockedPanel
      title={parts.title}
      sub={parts.sub}
      onClose={parts.onClose}
      footer={parts.footer}
    >
      {parts.children}
    </DockedPanel>
  );
}
